import PieChart from '../components/pie/pie.vue';
import BarChart from '../components/bar/bar.vue';
import LineChart from '../components/line/line.vue';
import MapChart from '../components/map/map.vue';
// import AMap from "AMap";
export default {
  name: 'cdyDistrict',
  components: {
    PieChart,
    BarChart,
    LineChart,
    MapChart
  },
  data() {
    return {
      progress: true,
      leftPanel2active1: true,
      leftPanel2active2: true,
      flag1: true,
      flag2: true,
      leftPanel1active1: true,
      leftPanel1active2: true,
      imgarr: [
        { url: "https://nfs.nxin.com/cms_image_859135d1-3a71-41c6-b49a-dd707a4a4cb9.png", show: true, name: "园区分布" },
        { url: "https://nfs.nxin.com/cms_image_cac7a52c-c18c-49ab-9f27-2a00002863d3.png", show: true, name: "草数据" },
        { url: "https://nfs.nxin.com/cms_image_edd6ff90-7722-4235-84b8-adbeaa48d5c8.png", show: true, name: "牛数据" },
        { url: "https://nfs.nxin.com/cms_image_70c271ea-bedb-4be1-a334-a093e29bd814.png", show: true, name: "马数据" },
        { url: "https://nfs.nxin.com/cms_image_4dd293cc-f816-4f5e-b497-7c4ba924bec8.png", show: true, name: "羊数据" }
      ],
      leftPanel1: {
        series: [
          {
            name: '燕麦草',
            unit: '亩',
            value: [426044.6, 448563.1, 391654, 405674, 32604, 427732, 415538, 455538],
            show: true,
            colors: 0,
            // stack: 'item',
          },
          {
            name: '苜蓿',
            unit: '亩',
            value: [162760, 24459.204, 240236.2, 317146, 278847, 256789, 268983, 308983],
            show: true,
            colors: 1,
            // stack: 'item',
          },
        ],
        category: ['2016年', '2017年', '2018年','2019年', '2020年', '2021年', '2022年', '2023年'],
      },
      infoWindow: "",
      leftPanel2: {
        series: [
          {
            name: '全国',
            unit: '万亩',
            show: true,
            colors: 0,
            value: [ 6418.45, 6119.06, 5707.54, 4843.65, 4245, 5843.65, 4245, 4895],
          },
          {
            name: '内蒙',
            unit: '万亩',
            show: true,
            colors: 1,
            value: [1896.35, 1788.2, 1723.31, 1698.76, 1687.5, 2698.76, 2487.5, 2987.5],
          },
        ],
        category: ['2017年', '2018年', '2019年', '2020年', '2021年', '2022年', '2023年'],
      },
      leftPanel3: {
        series: [
          {
            name: '平台覆盖牛源量趋势',
            value: [46889, 47041, 47672, 47789, 48788, 49002, 48702, 49047, 51788, 54002, 58702, 59047],
            colors: 0,
            show: true,
          },
        ],
        category: [
          ['01月', '2022年'],
          ['02月', '2022年'],
          ['03月', '2022年'],
          ['04月', '2022年'],
          ['05月', '2022年'],
          ['06月', '2022年'],
          ['07月', '2022年'],
          ['08月', '2022年'],
          ['09月', '2022年'],
          ['10月', '2022年'],
          ['11月', '2022年'],
          ['12月', '2022年'],
        ],
      },
      rightPanel1: {
        data: [
          { value: 45, name: '西门塔尔' },
          { value: 4, name: '三河牛' },
          { value: 6, name: '蒙古牛' },
          { value: 9, name: '科尔沁牛' },
          { value: 8, name: '羊' },
          { value: 80, name: '马' },
        ],
        unit: '万头',
        radius: ['47%', '80%'],
      },
      rightPanel2: {
        series: [
          {
            name: '地区覆盖牛源量趋势',
            value: [513645, 549228, 568467, 577993, 578308, 573408, 569253, 579993, 598308, 623408, 669253, 699253],
            show:true,
            colors:0,
          },
        ],
        category: [
          ['01', '2022'],
          ['02', '2022'],
          ['03', '2022'],
          ['04', '2022'],
          ['05', '2022'],
          ['06', '2022'],
          ['07', '2022'],
          ['08', '2022'],
          ['09', '2022'],
          ['10', '2022'],
          ['11', '2022'],
          ['12', '2022'],
        ],
      },
      rightPanel3: [0, 0, 0, 0],
    };
  },
  created() {
  },
  mounted() {
    this.rightPanel3 = [70, 19, 25, 50];
    this.showMap()
    setInterval(() => {
      this.progress = false;
      this.rightPanel3 = [0, 0, 0, 0];
      setTimeout(() => {
        this.progress = true;
        this.rightPanel3 = [70, 19, 25, 50];
      }, 300);
    }, 8000);
  },
  methods: {
    imgarrCLick(item) {
      item.show = !item.show
    },
    showMap() {
      let that = this
      let map = new AMap.Map("container", {
        center: [120.396832, 43.737726],
        layers: [new AMap.TileLayer.Satellite()],
        zoom: 15,
      });
      let arr = [1]
      let arr2 = arr.map((item, index) => {
        let marker = new AMap.Marker({
          icon: new AMap.Icon({
            image: "https://nfs.nxin.com/cms_image_cac7a52c-c18c-49ab-9f27-2a00002863d3.png",
            size: new AMap.Size(128, 128), //图标大小
            imageSize: new AMap.Size(64, 64),
          }),
          label: {
            direction: "top",
            content: "中国草都草业服务园区",
          },
          position: [120.396832, 43.737726], // 43.737726,120.396832
        });
        return marker
      })
      let markerList = arr2;
      map.add(markerList);
    },
    leftPanel2Click1() {
      this.leftPanel2active1 = !this.leftPanel2active1;
      this.leftPanel2.series[0].show = !this.leftPanel2.series[0].show;
      this.flag2 = !this.flag2;
    },
    leftPanel2Click2() {
      this.leftPanel2active2 = !this.leftPanel2active2;
      this.leftPanel2.series[1].show = !this.leftPanel2.series[1].show;
      this.flag2 = !this.flag2;
    },
    leftPanel1Click1() {
      this.leftPanel1active1 = !this.leftPanel1active1;
      this.leftPanel1.series[0].show = !this.leftPanel1.series[0].show;
      this.flag1 = !this.flag1;
    },
    leftPanel1Click2() {
      this.leftPanel1active2 = !this.leftPanel1active2;
      this.leftPanel1.series[1].show = !this.leftPanel1.series[1].show;
      this.flag1 = !this.flag1;
    },
    // createInfoWindow() {
    //   var content = "其其格草业公司"
    //   return content
    // }
  },

};
